import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import { useAuth } from '../context/AuthContext';

const RSMinCallbackPage = () => {
  const navigate = useNavigate();
  const { loginWithRSMinToken } = useAuth();
  const [error, setError] = useState('');
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const exchange = async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');
      const nextRoute = params.get('next') || '/dashboard';

      if (!token) {
        setError('Missing RSMin token in callback URL.');
        return;
      }

      try {
        await loginWithRSMinToken(token);
        const safeNext = nextRoute.startsWith('/') ? nextRoute : '/dashboard';
        navigate(safeNext, { replace: true });
      } catch (err) {
        setError(err.response?.data?.message || 'Unable to connect your RSMin account.');
      }
    };

    exchange();
  }, [loginWithRSMinToken, navigate]);

  return (
    <MainLayout>
      <div className="page auth-page">
        <h2>Connecting RSMin</h2>
        {error ? <div className="error-msg">{error}</div> : <p>Signing you in to CIP...</p>}
      </div>
    </MainLayout>
  );
};

export default RSMinCallbackPage;
